const SquaresLocalize = {
    'court successfully updated': 'Praça atualizada com sucesso!',
    'court successfully deleted': 'Praça deletada com sucesso!',
    'already exists a court with this description': 'já existe uma praça com esta descrição'

}

export default SquaresLocalize